import React from "react";
import { Navigate } from "react-router-dom";
import { useUserActions, getUser, getAccessToken, getRefreshToken} from "../hooks/user.actions";
import jwtDecode from "jwt-decode";
import { useDispatch } from "react-redux";
import { getUserDetails } from "../store/userdetails";

function ProtectedRoute({ children }){
    const userActions = useUserActions()
    const dispatch = useDispatch()

    try {
        const refresh = getRefreshToken()
        const userProfile = jwtDecode(refresh);
        const now = new Date().getTime() / 1000; // Date().getTime() returns milliseconds.
        // So divide by 1000 to get seconds
        if (now > userProfile.exp) {
            // user profile has expired.
            userActions.logout()
        }else{
            dispatch(getUserDetails())

        }
    }catch(error){
        console.error("Error decoding access token:", error);

    }
    
    const user = getUser() && getAccessToken() && getRefreshToken()

    const isAuthenticated = user !== null;

    return isAuthenticated ? (
        <React.Fragment>{children }</React.Fragment>
    ) : (
        <Navigate to="/login" />
    )
}

export default ProtectedRoute